import type { FilterGroup } from '@shared/flow/filter';

/**
 * Applied-filter count model for the V2 toolbar (plan 2026-09-27-007 D5/U1)
 * and V1 `FlowTable`. Pure: no React, no Glaze.
 *
 * The chip MODEL that used to live here (`appliedFilterChips`, `Chip`,
 * `withoutCondition`) was deleted by Spencer's QA round 1 item B
 * (2026-09-29, D-B1): inline applied-filter chips no longer render on any V2
 * toolbar, so the only consumer went away. Applied and locked rules are shown
 * inside the Filters popover (`filters/FilterPopover.tsx`), which already
 * renders a locked rule non-removable; the trigger keeps its `· N` count.
 */

/**
 * FlowTable's toolbar count (GTMOPS-2254): 0 for the rep's own conditions
 * while filters are bypassed; pinned conditions always count.
 */
export function activeFilterCount(
  filters: readonly FilterGroup[],
  pinnedConditions: readonly unknown[] | undefined,
  filtersBypassed: boolean,
): number {
  return (filtersBypassed ? 0 : filters.reduce((n, g) => n + g.conditions.length, 0)) + (pinnedConditions?.length ?? 0);
}
